export var getInputWrapperLss = function (_a) {
    var _b = _a.inputRowsCount, inputRowsCount = _b === void 0 ? 0 : _b, _c = _a.inputIndex, inputIndex = _c === void 0 ? 0 : _c, isFocused = _a.isFocused, isInvalid = _a.isInvalid;
    var lss = {
        borderTopRightRadius: 'sm',
        borderTopLeftRadius: 'sm',
        borderBottomLeftRadius: 'none',
        borderBottomRightRadius: 'none'
    };
    if (inputIndex === 0 && inputRowsCount > 1) {
        lss.borderBottomLeftRadius = 'none';
        lss.borderBottomRightRadius = 'none';
    }
    else if (inputIndex > 0 && inputIndex <= inputRowsCount - 1) {
        lss.mt = '-1px';
        lss.borderTopLeftRadius = 'none';
        lss.borderTopRightRadius = 'none';
        lss.borderBottomLeftRadius = 'none';
        lss.borderBottomRightRadius = 'none';
    }
    if (isFocused) {
        lss.borderTopColor = isInvalid ? 'danger500' : 'secondary500';
        lss.zIndex = 'formActions';
    }
    if (isInvalid) {
        lss.zIndex = 'notification';
    }
    return lss;
};
//# sourceMappingURL=inputRowWrapperStyling.js.map